import React from "react"
import Layout from "../components/layout"
import Head from "../components/head"

import { Link, graphql, useStaticQuery } from "gatsby"

import GallerySmall from "../components/gallerySmall"

const Zakochani = () => {
  const contentfullData = useStaticQuery(graphql`
    query {
      allContentfulAlbum(
        filter: { node_locale: { eq: "en-US" }, typ: { eq: "zakochani" } }
      ) {
        edges {
          node {
            nazwa
            typ
            zdjecie_albumu {
              fluid(maxHeight: 2000, maxWidth: 2000) {
                ...GatsbyContentfulFluid
              }
            }
          }
        }
      }
    }
  `)

  return (
    <Layout>
      <Head title="zakochani"></Head>
      <GallerySmall
        contentfullData={contentfullData}
        title="zakochani"
      ></GallerySmall>
    </Layout>
  )
}

export default Zakochani
